const PAGE_INSTRUCTIONS_UPDATED = 'PAGE_INSTRUCTIONS_UPDATED';
const MORE_INSTRUCTIONS_UPDATED = 'MORE_INSTRUCTIONS_UPDATED';

const initialPageInstructionsState = [
  {
    instructionId: 'coming-soon',
    instructionName: 'Coming soon.....',
    instructionLink: '#Link1',
  },
];
export const pageInstructionsReducer = (state = initialPageInstructionsState, action) => {
  switch (action.type) {
    case PAGE_INSTRUCTIONS_UPDATED: {
      return action.payload;
    }
    default:
      return state;
  }
};

const moreInstructionsState = [
  {
    instructionId: 'additional-helpContent',
    instructionName: 'Additional Help Content',
    instructionLink: 'https://www.americanexpress.com/content/dam/amex/us/merchant/pdf/FileXpress-User-Guide.pdf',
  },
];

export const moreInstructionsReducer = (state = moreInstructionsState, action) => {
  switch (action.type) {
    case MORE_INSTRUCTIONS_UPDATED: {
      return action.payload;
    }
    default:
      return state;
  }
};
